<main class="home primary-text">
  <section class="container head-wrapper">
    <div class="row gx-0">
      <div class="col-lg-6">
        <div class="head-text">
          Redefining <strong class="under-img">enterprise</strong>
          AI solutions.
        </div>
      </div>
    </div>
    <div class="row gx-0">
      <div class="col-lg-6 pt-4 pt-lg-5">
        <div class="head-sub">
          Qeleo builds cutting-edge and cost-effective AI solutions tailored for
          business.
        </div>
      </div>
      <div class="col-lg-6 pattern-bg">
        <app-user-cta></app-user-cta>
      </div>
    </div>
  </section>
  <section class="consultancy-head container d-lg-none">
    <app-consultancy-head></app-consultancy-head>
  </section>
  <section class="consultancy-head d-none d-lg-block">
    <app-consultancy-head></app-consultancy-head>
  </section>
  <section class="products-container container d-flex flex-column">
    <div class="row title-wrapper">
      <div class="col-lg-6">
        <div class="title">
          Qeleo <strong class="under-img">solutions</strong>.
        </div>
      </div>
      <div class="col-lg-6">
        <div class="sub-title">
          We build versatile and powerful AI environments to give you access to
          Qeleo AI in the easiest and most direct way we could imagine.
        </div>
      </div>
    </div>
    <div class="accordion-wrapper">
      <div
        (inViewport)="onInViewport($event, 'productsAccordion')"
        appViewport
        class="accordion-inner-wrapper row"
      >
        <div class="col-lg-6">
          <div
            #productAccordion="ngbAccordion"
            [closeOthers]="true"
            ngbAccordion
          >
            <div
              (mouseenter)="onHover('developer', 'productsAccordion')"
              (mouseleave)="hoverOut('developer', 'productsAccordion')"
              [collapsed]="false"
              class="primary-text"
              ngbAccordionItem="developer"
            >
              <div ngbAccordionHeader>
                <button
                  (click)="onToggle('developer', $event)"
                  class="d-flex align-items-center h2-sm"
                  ngbAccordionButton
                >
                  /Developer Hub
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div class="d-flex flex-column" ngbAccordionBody>
                  <span class="ms-1 product-desc"
                    >For API engineers: a customizable testing environment to
                    analyze and optimize calls.</span
                  >
                  <div class="d-flex d-lg-block">
                    <a
                      target="_blank"
                      href="https://qeleo.ai/developer-hub"
                      class="free-btn ms-1 btn rounded-pill d-flex flex-grow-1 justify-content-center align-items-center btn-sm"
                    >
                      try free
                      <app-qeleo-icon
                        iconName="arrow-right-o"
                        size="sm"
                      ></app-qeleo-icon>
                    </a>
                  </div>
                  <div
                    class="img-wrapper flex-column gap-3 align-items-center justify-content-center z-1 d-flex d-lg-none"
                  >
                    <div class="img-bg">
                      <img [src]="activeProductImage" class="image" />
                    </div>
                    <div class="btn-group theme-btn" role="group">
                      <button
                        (click)="setTheme('dark')"
                        class="btn left-btn pe-1 ps-2"
                        type="button"
                      >
                        <app-qeleo-icon
                          [className]="
                            selectedTheme === 'dark'
                              ? 'active q-purple-s-text invert-text rounded-circle p-1'
                              : 'invert-text rounded-circle p-1'
                          "
                          [size]="'md'"
                          iconName="moon-o"
                        ></app-qeleo-icon>
                      </button>
                      <button
                        (click)="setTheme('light')"
                        class="btn right-btn ps-1 pe-2"
                        type="button"
                      >
                        <app-qeleo-icon
                          [className]="
                            selectedTheme === 'light'
                              ? 'active q-purple-s-text invert-text rounded-circle p-1'
                              : 'invert-text rounded-circle p-1'
                          "
                          [size]="'md'"
                          iconName="light-theme-o"
                        ></app-qeleo-icon>
                      </button>
                    </div>
                  </div>
                  <ngb-progressbar
                    [value]="accordionProgressValue"
                    class="accordion-progressbar"
                    height="4px"
                  ></ngb-progressbar>
                </div>
              </div>
            </div>
            <div
              (mouseenter)="onHover('prompt', 'productsAccordion')"
              (mouseleave)="hoverOut('prompt', 'productsAccordion')"
              class="primary-text"
              ngbAccordionItem="prompt">
              <div ngbAccordionHeader>
                <button
                  (click)="onToggle('prompt', $event)"
                  class="d-flex align-items-center h2-sm"
                  ngbAccordionButton
                >
                  /Prompt IDE
                  <span
                    class="ms-2 badge rounded-pill heading-badge link-text btn-xs"
                    >qeleo labs</span
                  >
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div class="d-flex flex-column" ngbAccordionBody>
                  <span class="product-desc ms-1"
                    >For prompt sculptors: compose, test, optimize and deploy.
                    Repeat.</span
                  >
                  <div class="d-flex d-lg-block">
                    <a
                      target="_blank"
                      href="https://qeleo.ai/prompt-ide"
                      class="free-btn ms-1 btn rounded-pill d-flex flex-grow-1 justify-content-center align-items-center btn-sm"
                    >
                      try free
                      <app-qeleo-icon
                        iconName="arrow-right-o"
                        size="sm"
                      ></app-qeleo-icon>
                    </a>
                  </div>
                  <div
                    class="img-wrapper flex-column gap-3 align-items-center justify-content-center z-1 d-flex d-lg-none"
                  >
                    <div class="img-bg">
                      <img [src]="activeProductImage" class="image" />
                    </div>
                    <div class="btn-group theme-btn" role="group">
                      <button
                        (click)="setTheme('dark')"
                        class="btn left-btn pe-1 ps-2"
                        type="button"
                      >
                        <app-qeleo-icon
                          [className]="
                            selectedTheme === 'dark'
                              ? 'active q-purple-s-text invert-text rounded-circle p-1'
                              : 'invert-text rounded-circle p-1'
                          "
                          [size]="'md'"
                          iconName="moon-o"
                        ></app-qeleo-icon>
                      </button>
                      <button
                        (click)="setTheme('light')"
                        class="btn right-btn ps-1 pe-2"
                        type="button"
                      >
                        <app-qeleo-icon
                          [className]="
                            selectedTheme === 'light'
                              ? 'active q-purple-s-text invert-text rounded-circle p-1'
                              : 'invert-text rounded-circle p-1'
                          "
                          [size]="'md'"
                          iconName="light-theme-o"
                        ></app-qeleo-icon>
                      </button>
                    </div>
                  </div>
                  <ngb-progressbar
                    [value]="accordionProgressValue"
                    class="accordion-progressbar"
                    height="4px"
                  ></ngb-progressbar>
                </div>
              </div>
            </div>
            <div
              (mouseenter)="onHover('chat', 'productsAccordion')"
              (mouseleave)="hoverOut('chat', 'productsAccordion')"
              class="primary-text"
              ngbAccordionItem="chat">
              <div ngbAccordionHeader>
                <button
                  (click)="onToggle('chat', $event)"
                  class="d-flex align-items-center h2-sm"
                  ngbAccordionButton
                >
                  /Chat
                  <span
                    class="ms-2 badge rounded-pill heading-badge link-text btn-xs"
                    >qeleo labs</span
                  >
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div class="d-flex flex-column" ngbAccordionBody>
                  <span class="ms-1 product-desc"
                    >New to AI? Explore our multimodal Capabilities in our most
                    accessible environment.</span
                  >
                  <div class="d-flex d-lg-block">
                    <a
                      target="_blank"
                      href="https://qeleo.ai/chat"
                      class="free-btn ms-1 btn rounded-pill d-flex flex-grow-1 justify-content-center align-items-center btn-sm"
                    >
                      try free
                      <app-qeleo-icon
                        iconName="arrow-right-o"
                        size="sm"
                      ></app-qeleo-icon>
                    </a>
                  </div>
                  <div
                    class="img-wrapper flex-column gap-3 align-items-center justify-content-center z-1 d-flex d-lg-none"
                  >
                    <div class="img-bg">
                      <img [src]="activeProductImage" class="image" />
                    </div>
                    <div class="btn-group theme-btn" role="group">
                      <button
                        (click)="setTheme('dark')"
                        class="btn left-btn pe-1 ps-2"
                        type="button"
                      >
                        <app-qeleo-icon
                          [className]="
                            selectedTheme === 'dark'
                              ? 'active q-purple-s-text invert-text rounded-circle p-1'
                              : 'invert-text rounded-circle p-1'
                          "
                          [size]="'md'"
                          iconName="moon-o"
                        ></app-qeleo-icon>
                      </button>
                      <button
                        (click)="setTheme('light')"
                        class="btn right-btn ps-1 pe-2"
                        type="button"
                      >
                        <app-qeleo-icon
                          [className]="
                            selectedTheme === 'light'
                              ? 'active q-purple-s-text invert-text rounded-circle p-1'
                              : 'invert-text rounded-circle p-1'
                          "
                          [size]="'md'"
                          iconName="light-theme-o"
                        ></app-qeleo-icon>
                      </button>
                    </div>
                  </div>
                  <ngb-progressbar
                    [value]="accordionProgressValue"
                    class="accordion-progressbar"
                    height="4px"
                  ></ngb-progressbar>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="preview col-lg-6 d-flex align-items-center">
          <!--                    <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>-->
          <div
            class="img-wrapper flex-column gap-3 align-items-center justify-content-center z-1 d-none d-lg-flex"
          >
            <div class="img-bg">
              <img [src]="activeProductImage" class="image" />
            </div>
            <div class="btn-group theme-btn z-2 position-absolute" role="group">
              <button
                (click)="setTheme('dark')"
                class="btn left-btn pe-1 ps-2"
                type="button"
              >
                <app-qeleo-icon
                  [className]="
                    selectedTheme === 'dark'
                      ? 'active q-purple-s-text invert-text rounded-circle p-2'
                      : 'invert-text rounded-circle p-2'
                  "
                  [size]="'xxxl'"
                  iconName="moon-o"
                ></app-qeleo-icon>
              </button>
              <button
                (click)="setTheme('light')"
                class="btn right-btn ps-1 pe-2"
                type="button"
              >
                <app-qeleo-icon
                  [className]="
                    selectedTheme === 'light'
                      ? 'active q-purple-s-text invert-text rounded-circle p-2'
                      : 'invert-text rounded-circle p-2'
                  "
                  [size]="'xxxl'"
                  iconName="light-theme-o"
                ></app-qeleo-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="performance-container container d-flex flex-column justify-content-center">
    <div class="title-wrapper d-flex flex-column align-items-center my-auto">
      <div class="title d-flex flex-column">
        <div class="d-lg-none">
          The Mix of Experts
          <div>model: <strong class="under-img">Tesseract </strong>2.0.</div>
        </div>
        <!-- } @else { -->
        <div class="d-none d-lg-block">
          <div>The Mix of Experts</div>
          <div class="d-flex w-100 justify-content-end">
            model: <strong class="under-img">Tesseract 2.0.</strong>
          </div>
        </div>
      </div>
      <div class="sub-title body-2-lg text-lg-center">
        Tesseract is our multimodal Mix of Experts (MoE) model. MoE
        architectures efficiently delegate specialized tasks to different expert
        networks, enhancing learning speed and performance for complex problems.
      </div>
      <div class="sub-title body-2-lg text-lg-center">
        The bottom line: Qeleo Tesseract 2.0 outperforms the opposition in
        benchmark tests, showcasing proficiency across 57 diverse modalities.
      </div>
    </div>
    <div
      (inViewport)="onInViewport($event, 'performanceCards')"
      appViewport
      class="performance-wrapper row gx-2"
    >
      @for (performance of performanceArr; track $index) {
      <div class="col-lg-4 position-relative">
        <ng-container
          *ngTemplateOutlet="
            cardTemplate;
            context: {
              performance: performance,
              showPerformanceCard:
              ((hoverCardIndex !== -1) ? $index === hoverCardIndex : $index === currentCardIndex) && showPerformanceCard,
              index: $index
            }
          "
        ></ng-container>
        @if($index === 1){
        <div class="position-absolute dotted d-none d-lg-flex"></div>
        }
      </div>
      }
      <div class="position-absolute dotted d-lg-none"></div>
    </div>
  </section>
  <section class="container partner-container d-flex flex-column justify-content-center">
    <div class="title-wrapper d-flex flex-column align-items-center my-auto">
      <div class="title d-flex flex-column w-100">
        <div class="d-lg-none">
          Partners, clients & <strong class="under-img">affiliates.</strong>
        </div>
        <div class="d-none d-lg-block">
          <div>Partners, <strong class="under-img">clients </strong></div>
          <div class="d-flex justify-content-end">
            <span>& affiliates.</span>
          </div>
        </div>
      </div>
      <div class="text-lg-center sub-title">
        Since 2016, Qeleo has been researching and delivering artificial
        intelligence solutions to AAA enterprises and tech startups alike.
        Vertically agnostic, endlessly scalable.
      </div>
    </div>
    <ngb-carousel
      [interval]="3000"
      [showNavigationArrows]="false"
      [showNavigationIndicators]="true"
      class="partner-carousel d-lg-none"
    >
      <ng-template ngbSlide>
        <div class="partner-pill-wrapper">
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img src="../../../assets/images/clients/american_airlines.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container" style="padding: 20px">
              <img src="../../../assets/images/clients/charge.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img src="../../../assets/images/clients/denver_Health.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img src="../../../assets/images/clients/hyatt_regency.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img src="../../../assets/images/clients/mercedes.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container" style="padding: 15px">
              <img src="../../../assets/images/clients/nike.png" />
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <div class="partner-pill-wrapper">
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img src="../../../assets/images/clients/nrel.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img src="../../../assets/images/clients/orlando_airport.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img src="../../../assets/images/clients/sprint.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container" style="padding: 20px">
              <img src="../../../assets/images/clients/toyota.png" />
            </div>
          </div>
          <div
            class="partner-pill d-flex align-items-center justify-content-center"
          >
            <div class="img-container">
              <img
                src="../../../assets/images/clients/unites_steates_mint.png"
              />
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-carousel>
    <div class="justify-content-center gap-2 flex-wrap d-none d-lg-flex">
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/american_airlines.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container" style="padding: 20px">
          <img src="../../../assets/images/clients/charge.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/denver_Health.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/hyatt_regency.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/mercedes.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container" style="padding: 15px">
          <img src="../../../assets/images/clients/nike.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/nrel.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/orlando_airport.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/sprint.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container" style="padding: 20px">
          <img src="../../../assets/images/clients/toyota.png" />
        </div>
      </div>
      <div
        class="partner-pill d-flex align-items-center justify-content-center"
      >
        <div class="img-container">
          <img src="../../../assets/images/clients/unites_steates_mint.png" />
        </div>
      </div>
    </div>
  </section>
  <section class="pricing-card-wrapper">
    <app-pricing-head [isFromPricingPage]="false"></app-pricing-head>
  </section>
</main>

<ng-template
  #cardTemplate
  let-index="index"
  let-performance="performance"
  let-showPerformanceCard="showPerformanceCard"
>
  <div
    (mouseenter)="onHover(index, 'performanceCards')"
    (mouseleave)="hoverOut(index, 'performanceCards')"
    (click)="startFromCard(index); hoverCardIndex = -1"
    [class.active]="(hoverCardIndex !== -1) ? index === hoverCardIndex : index === currentCardIndex"
    class="position-relative card-container w-100"
  >
    <div
      [ngClass]="showPerformanceCard ? 'd-none' : 'd-flex'"
      class="position-absolute text-card flex-column"
    >
      <div class="title">
        {{ performance?.title }}<span class="percent">%</span>
      </div>
      <div class="ps-1 ps-lg-2 card-sub-title">
        {{ performance?.subTitle }}
      </div>
    </div>
    <div
      [ngClass]="showPerformanceCard ? 'd-flex' : 'd-none'"
      class="position-absolute card detail-card primary-text"
    >
      <div class="card-body d-flex flex-column">
        <div class="card-title-wrapper d-flex flex-column">
          <div class="title">
            {{ performance?.title }}<span class="percent">%</span>
          </div>
          <div class="ps-1 ps-lg-2 card-sub-title">
            {{ performance?.subTitle }}
          </div>
        </div>
        <div class="ps-1 ps-lg-2 card-text flex-grow-1 body-4-lg">
          {{ performance?.description }}
        </div>
        <ngb-progressbar
          [value]="cardProgressValue"
          class="ps-2"
          height="4px"
        ></ngb-progressbar>
      </div>
    </div>
  </div>
</ng-template>
